// @core/api/endpoints/authn/verify_two_factor_auth.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  VerifyTwoFactorAuthRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Verify 2FA code
 * Validates a 6-digit TOTP code from the user's authenticator app. Used during login when 2FA is enabled and for confirming 2FA setup completion.
 */
export async function VerifyTwoFactorAuth(
  data: VerifyTwoFactorAuthRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/2fa/verify`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
